import { burger } from "./components/burger";
import { scroll } from "./components/scroll";
import { spoller } from "./components/spoller";

burger();
scroll();
spoller();
